import { render, staticRenderFns } from "./InfopointScreenshot.vue?vue&type=template&id=522aa11e&scoped=true"
import script from "./InfopointScreenshot.vue?vue&type=script&lang=js"
export * from "./InfopointScreenshot.vue?vue&type=script&lang=js"
import style0 from "./InfopointScreenshot.vue?vue&type=style&index=0&id=522aa11e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522aa11e",
  null
  
)

export default component.exports